<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="projectRules"
    label='Project Id'
    data-track="project-id"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputProjectId extends Vue {
  projectRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Project Id is required'];
}
</script>
